(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({"./src/js/mydashboard":[function(require,module,exports){
(function (global){
'use strict';

var resourcesTable = null;

var formatTitle = function(cell, cellData, rowData) {
    var title = rowData.title;
    var resourceId = rowData.id;
    var url = rowData.url;

    var $a = $('<a>').attr('href', url).addClass('title').append(title);
    var $cell = $(cell).empty();

    $cell.append($a);
};

var formatSparkline = function(cell, cellData, rowData) {
    var $cell = $(cell).empty();
    var resourceId = rowData.id;

    $cell.append('<div class="sparkline pull-right res-' + resourceId + '"></div>');
}

var renderResourcesTable = function() {
    var columns = [
        {
            title: 'Title',
            name: 'title',
            className: 'title',
            createdCell: formatTitle,
            data: 'title',
            searchable: true
        },
        {
            title: 'Downloads',
            name: 'downloads',
            className: 'downloads',
            id: 'id',
            searchable: false,
            type: 'num',
            data: 'downloadCount'
        },
        {
            title: 'Views',
            name: 'views',
            className: 'views',
            id: 'id',
            searchable: false,
            type: 'num',
            data: 'viewCount'
        },
        {
            name: 'sparkline',
            className: 'sparkline-cell',
            createdCell: formatSparkline,
            data: 'id',
            searchable: false,
            sortable: false
        }
    ];

    $.fn.dataTableExt.sErrMode = 'throw';

    var $table = $('<table class="table table-striped table-hover resources-table" cellpadding="0" cellspacing="0" border="0"></table>');
    $('.resources-table-container').html($table);

    resourcesTable = $table.DataTable({
        ajax: {
            url: '/my-dashboard/resources.json',
            dataSrc: ''
        },
        paging: true,
        pageLength: 50,
        lengthChange: false,
        pagingType: 'full_numbers',
        ordering: true,
        searching: true,
        dom: 'ftSip',
        deferRender: true,
        saveState: true,
        columns: columns
    });

    $table.on('xhr.dt', function(event, settings, json) {
        _.defer(function() {
            var totalViews = 0;
            var totalDownloads = 0;

            _.each(json, function(row) {
                if (row.viewCount) totalViews += row.viewCount;
                if (row.downloadCount) totalDownloads += row.downloadCount;
            });

            // TODO locale-specific formatting
            $('.views .info-number').text(totalViews);
            $('.downloads .info-number').text(totalDownloads);
        });
    });

    $table.on('draw.dt', function() {
        drawSparklines();
    });

    //  TODO(sid); style the table;
};

var renderDownloadChart = function() {
    var url = '/stats/resourceAuthorId/me/daily/7';

    $.getJSON(url).done(function(data) {

        var $chartEl = $('.downloads-chart');
        $chartEl.highcharts({
            title: {
                text: 'Downloads last week',
                style: {
                    'text-transform': 'uppercase',
                    color: '#666C77',
                    'font-size': '14px'
                },
                align: 'left'
            },
            plotOptions: {
                series: {
                    marker: {
                        radius: 6,
                        states: {
                            hover: {
                                fillColor: 'white'
                            }
                        }
                    }
                }
            },
            xAxis: {
                categories: data.header.dates,
                gridLineWidth: 1,
                title: null
            },
            loading: {
                hideDuration: 5000
            },
            yAxis: {
                gridLineWidth: 0,
                title: null,
                minRange : 0.1
            },
            legend: {
                enabled: false
            },
            tooltip: {
                backgroundColor: '#5C626D',
                borderWidth: 0,
                style: {
                    color: 'white',
                    fontSize: '14px',
                    padding: '10px'
                },
                formatter: function () {
                    return this.y;
                }
            },
            series: [{
                data: data.downloads[0]
            }]
        });

        alignChartToBottomIfNeeded($chartEl.highcharts());
    });
};

var sparklinesData = {};
var sparklinesRendered = {};

var isRowVisible = function(resourceId) {
    var $el = $('.sparkline.res-' + resourceId);
    return $el.length > 1 && $el.is(':visible');
};

var destroySparklinesObject = function(resourceId) {
    if (!sparklinesRendered[resourceId]) {
        return;
    }

    sparklinesRendered[resourceId].highcharts().destroy();
    sparklinesRendered[resourceId] = undefined;
    delete sparklinesRendered[resourceId];
};

var drawSparklines = function() {
    // if we have sparkline data for the visible cells then render the sparkline
    var noDataResourceIds = [];

    resourcesTable.$('tr:visible', {filter:'applied'}).each(function(index, el) {
        var resourceId = resourcesTable.row(el).data().id;

        if (sparklinesData[resourceId]) {
            _.defer(function() {
                renderSparkline(resourceId);
            });
        } else {
            noDataResourceIds.push(resourceId);
        }
    });

    if (noDataResourceIds.length) {
        var days = 7;
        var url = 'stats/resource/' + noDataResourceIds.join(',') + '/daily/' + days;

        $.getJSON(url).done(function(data) {
            var idsMap = data.header.idMap;

            // Get the id from the idMap and use its index to find the downloads
            // Key is the resourceId, value is the index on the arrays
            _.each(idsMap, function(resourceIndexOnData, resourceId) {
                sparklinesData[resourceId] = data.downloads[resourceIndexOnData];

                _.defer(function() {
                    renderSparkline(resourceId);
                });
            });
        });
    }

    // delete sparklines for non-visible cells
    _.each(sparklinesRendered, function($elem, resourceId) {
        if (!$elem.is(':visible')) {
            destroySparklinesObject(resourceId);
        }
    });
};

var renderSparkline = function(resourceId) {
    if (isRowVisible(resourceId)) {
        return;
    }

    var data = sparklinesData[resourceId];

    if (!data) {
        return;
    }

    var sparklineOptions = {
        series: [{
            data: data,
            pointStart: 1
        }],
        chart: {
            renderTo: this,
            backgroundColor: null,
            borderWidth: 0,
            type: 'area',
            margin: [2, 0, 2, 0],
            width: 120,
            height: 20,
            style: {
                overflow: 'visible'
            },
            skipClone: true
        },
        title: {
            text: ''
        },
        credits: {
            enabled: false
        },
        xAxis: {
            labels: {
                enabled: false
            },
            title: {
                text: null
            },
            startOnTick: false,
            endOnTick: false,
            tickPositions: []
        },
        yAxis: {
            endOnTick: false,
            startOnTick: false,
            labels: {
                enabled: false
            },
            title: {
                text: null
            },
            tickPositions: [0]
        },
        legend: {
            enabled: false
        },
        tooltip: {
            backgroundColor: null,
            borderWidth: 0,
            shadow: false,
            useHTML: true,
            hideDelay: 0,
            shared: true,
            padding: 0,
            positioner: function (w, h, point) {
                return { x: point.plotX - w / 2, y: point.plotY - h};
            },
            formatter: function () {
                return this.y;
            }
        },
        plotOptions: {
            series: {
                animation: false,
                lineWidth: 1,
                shadow: false,
                states: {
                    hover: {
                        lineWidth: 1
                    }
                },
                marker: {
                    radius: 1,
                    states: {
                        hover: {
                            radius: 2
                        }
                    }
                },
                fillOpacity: 0.25
            },
            column: {
                negativeColor: '#910000',
                borderColor: 'silver'
            }
        }
    };

    if (sparklinesRendered[resourceId]) {
        destroySparklinesObject(resourceId);
    }

    var $chartEl = $('.sparkline.res-' + resourceId).highcharts(sparklineOptions);
    sparklinesRendered[resourceId] = $chartEl;
};

function alignChartToBottomIfNeeded(chart) {
    // http://stackoverflow.com/a/17367605/1664346
    if(chart.yAxis[0].dataMax === 0) {
        chart.yAxis[0].setExtremes(0, 5);
    }
};

$(global.document).ready(function() {
    _.defer(renderResourcesTable);
    _.defer(renderDownloadChart);
});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}]},{},["./src/js/mydashboard"]);
